import * as t from "io-ts";
import nullable from "./nullable";
export const INVOICE_LINE_DESCRIPTION_KEY = "invoiceLineDescription";
export const NO_PRODUCT_KEY = "noProduct";
const valuesT = t.array(t.string);
export const autocompleteSuggestionsT = t.record(t.string, t.union([valuesT, t.record(t.string, valuesT)]));
export const deleteAutocompleteSuggestionT = t.intersection([
    t.strict({ key: t.string, value: t.string }),
    t.partial({ productId: nullable(t.string) }),
]);
export const splitAutocompleteSuggestions = (record) => {
    const { [INVOICE_LINE_DESCRIPTION_KEY]: descriptions, ...rest } = record;
    const fields = {};
    for (const [key, value] of Object.entries(rest)) {
        if (Array.isArray(value))
            fields[key] = value;
    }
    return {
        fields,
        invoiceLineDescriptions: descriptions && !Array.isArray(descriptions) ? descriptions : {},
    };
};
export const joinAutocompleteSuggestions = (split) => ({
    ...split.fields,
    [INVOICE_LINE_DESCRIPTION_KEY]: split.invoiceLineDescriptions,
});
//# sourceMappingURL=autocomplete-suggestions.js.map